const VERSION = '3.9.0';
export default VERSION;
